import { IAuthenticationContext, IUser } from "~/ad-authentication/Interfaces";

export class CypressAuthenticationContext implements IAuthenticationContext {

    public constructor() {
        // No need of initializing authentication context
        return;
    }

    public async acquireToken(resourceId: string): Promise<string> {
        return Promise.resolve(localStorage.getItem(resourceId) ?? sessionStorage.getItem(resourceId) ?? "")
    }

    public async getCurrentUser(): Promise<IUser> {
        const currentUser: IUser = {
            userName: localStorage.getItem("auth.username") ?? "",
            profile: { oid: localStorage.getItem("auth.localaccountid") ?? "" },
        };
        return Promise.resolve(currentUser);
    }

    public async tryHandleWindowCallBack(): Promise<boolean> {
        return Promise.resolve(true);
    }

    public async isTokenRenewalInProgress(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
